import React, { Component } from "react";
import { Link } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { FUNNEL_START } from 'utils/constants';

const LayerBar = ({ width = 72 }) => (
  <div className="jl-layers" style={{ width }} aria-hidden="true">
    {['#5A6672', '#7B8894', '#93A6B4', '#A3BACB', '#90AFC4', '#7FA4BE', '#D5232E'].map((c, i) => (
      <span key={i} style={{ background: c }} />
    ))}
  </div>
);

class JobLanding extends Component {

  constructor(props) {
    super(props);
    this.state = { sessionId: null };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = this.props.funnelConfig.documentTitle;
    const params = new URLSearchParams(this.props.location.search);
    const funnelId = params.get('funnel_id');
    const utmContent = params.get('utm_content');
    fetch(FUNNEL_START, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ funnel_id: funnelId, utm_content: utmContent }),
    })
      .then(res => res.json())
      .then(data => this.setState({ sessionId: data.session_id }))
      .catch(() => {});
  }

  buildLink(path) {
    const params = new URLSearchParams(this.props.location.search);
    if (this.state.sessionId) params.set('session_id', this.state.sessionId);
    return `${path}?${params.toString()}`;
  }

  get quizLink() { return this.buildLink('/job/quiz'); }
  get infoLink() { return this.buildLink('/job/info'); }

  renderStyles() {
    return (
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=Barlow:wght@400;500;600;700&display=swap');

        .jl-page {
          font-family: 'Barlow', system-ui, -apple-system, sans-serif;
          color: #1D2732;
          background: #fff;
          max-width: 480px;
          margin: 0 auto;
          padding-bottom: 40px;
        }
        .jl-display {
          font-family: 'Barlow Condensed', 'Barlow', sans-serif;
          font-weight: 700;
          letter-spacing: 0.01em;
          text-transform: uppercase;
        }
        .jl-eyebrow {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.14em;
          font-size: 13px;
          color: #6B7D8D;
          margin-bottom: 6px;
        }
        .jl-layers { display: flex; flex-direction: column; gap: 2px; margin: 10px auto 20px; }
        .jl-layers span { display: block; height: 3px; border-radius: 2px; }

        .jl-cta {
          display: block;
          width: 100%;
          background: #D5232E;
          color: #fff;
          text-align: center;
          font-weight: 700;
          font-size: 16px;
          padding: 15px 20px;
          border-radius: 12px;
          text-decoration: none;
          box-shadow: 0 6px 16px rgba(213,35,46,.28);
          transition: transform .12s ease, background .12s ease;
        }
        .jl-cta:hover, .jl-cta:focus-visible { background: #B81C26; color: #fff; transform: translateY(-1px); }

        .jl-cta-secondary {
          display: block;
          width: 100%;
          background: transparent;
          color: #17293C;
          border: 2px solid #C2D2DE;
          text-align: center;
          font-weight: 600;
          font-size: 15px;
          padding: 13px 20px;
          border-radius: 12px;
          text-decoration: none;
          transition: border-color .12s ease, background .12s ease;
        }
        .jl-cta-secondary:hover, .jl-cta-secondary:focus-visible {
          border-color: #17293C; background: #EEF3F7; color: #17293C;
        }

        .jl-stickybar {
          position: fixed; bottom: 0; left: 50%; transform: translateX(-50%);
          width: 100%; max-width: 480px; z-index: 50;
          background: rgba(255,255,255,.96);
          backdrop-filter: blur(8px);
          border-top: 1px solid #E3EAF0;
          padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
        }
        .jl-stickybar .jl-cta { padding: 13px 16px; font-size: 15px; box-shadow: none; }

        .jl-hero { position: relative; height: 420px; overflow: hidden; background: #17293C; }
        .jl-hero img.jl-hero-img {
          width: 100%; height: 100%; object-fit: cover; object-position: center top;
          opacity: .92;
        }
        .jl-hero::after {
          content: ''; position: absolute; inset: 0;
          background: linear-gradient(180deg, rgba(23,41,60,.10) 0%, rgba(23,41,60,0) 32%, rgba(23,41,60,.9) 76%, #17293C 100%);
        }
        .jl-hero-content { position: absolute; left: 0; right: 0; bottom: 0; z-index: 2; padding: 20px; color: #fff; }
        .jl-hero-logo { position: absolute; top: 14px; right: 16px; z-index: 2; height: 40px; background: rgba(255,255,255,.95); border-radius: 8px; padding: 5px 10px; }
        .jl-hero-logo img { height: 100%; object-fit: contain; }
        .jl-chip {
          display: inline-block; background: #cae2f3; color: #14222F;
          font-family: 'Barlow Condensed', sans-serif; font-weight: 600; text-transform: uppercase;
          letter-spacing: .1em; font-size: 12.5px; padding: 4px 10px; border-radius: 4px; margin-bottom: 10px;
        }
        .jl-hero h1 { font-size: 28px; line-height: 1.1; margin: 0 0 6px; }
        .jl-hero .jl-hero-sub { color: #ffffff; font-size: 15px; margin: 0; }

        .jl-facts {
          display: grid; grid-template-columns: 1fr 1fr;
          background: #fff;
        }
        .jl-fact {
          background: #fff;
          padding: 16px;
          border-right: 1px solid #E3E0D9;
          border-bottom: 1px solid #E3E0D9;
        }
        .jl-fact:nth-child(even) { border-right: none; }
        .jl-facts { border-bottom: 1px solid #E3E0D9; }
        .jl-fact-label { font-size: 14px; color: #4c555c; display: block; margin-bottom: 4px; }
        .jl-fact b { display: block; font-size: 15px; font-weight: 700; color: #1D2732; line-height: 1.3; }

        .jl-section { padding: 32px 20px 8px; text-align: center; }
        .jl-section h2 { font-size: 30px; line-height: 1.02; margin: 0; }

        .jl-badges { display: flex; justify-content: center; gap: 10px; margin: 18px 0 22px; flex-wrap: wrap; }
        .jl-badge {
          display: flex; align-items: center; gap: 8px;
          background: #EEF3F7; border: 1px solid #D8E3EB; border-radius: 999px;
          padding: 8px 14px; font-size: 13.5px; font-weight: 600; color: #17293C;
        }
        .jl-badge i { color: #D5232E; font-size: 16px; }

        .jl-footer { padding: 28px 20px calc(20px + env(safe-area-inset-bottom)); font-size: 12px; color: #7A8A98; text-align: center; }
        .jl-footer a { color: #3E5A70; }

        @media (prefers-reduced-motion: reduce) {
          .jl-cta, .jl-cta-secondary { transition: none; }
        }
      `}</style>
    );
  }

  renderHero() {
    const { companyLogo, companyName, aiDisclaimer, landing } = this.props.funnelConfig;
    return (
      <header className="jl-hero">
        <div className="jl-hero-logo">
          <img src={companyLogo} alt={companyName} />
        </div>
        <div style={{ position: 'absolute', top: 14, left: 16, zIndex: 2 }}>
          <img src={aiDisclaimer} alt="AI Disclaimer" style={{ height: 20, objectFit: 'contain' }} />
        </div>
        <img src={landing.heroImg} alt="" className="jl-hero-img" />
        <div className="jl-hero-content">
          <span className="jl-chip">{landing.chipText}</span>
          <h1 className="jl-display">{landing.heroTitle}</h1>
          <p className="jl-hero-sub">{landing.heroSubtitle}</p>
        </div>
      </header>
    );
  }

  renderEarlyCta() {
    return (
      <div style={{ background: '#17293C', borderTop: '1px solid rgba(144,175,196,0.25)', borderBottom: '1px solid rgba(144,175,196,0.25)', padding: '24px 20px' }}>
        <Link to={this.quizLink} className="jl-cta">
          Jetzt bewerben
        </Link>
        <div className="jl-badges" style={{ marginTop: 16, marginBottom: 0 }}>
          <span className="jl-badge" style={{ background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(144,175,196,0.4)', color: '#fff' }}>
            <i className="bi bi-stopwatch" style={{ color: '#90AFC4' }} /> Unter 60 Sekunden
          </span>
          <span className="jl-badge" style={{ background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(144,175,196,0.4)', color: '#fff' }}>
            <i className="bi bi-file-earmark-x" style={{ color: '#90AFC4' }} /> Kein Lebenslauf nötig
          </span>
        </div>
      </div>
    );
  }

  renderFacts() {
    const { landing } = this.props.funnelConfig;
    return (
      <div className="jl-facts">
        {landing.facts.map((fact, i) => (
          <div key={i} className="jl-fact">
            <span className="jl-fact-label">{fact.subtitle}</span>
            <b>{fact.title}</b>
          </div>
        ))}
      </div>
    );
  }

  renderQuizPitch() {
    return (
      <section className="jl-section">
        <p style={{ fontSize: 15, color: '#1D2732', textAlign: 'left', marginBottom: 24, lineHeight: 1.6 }}>
          <strong>So funktioniert's:</strong> Du beantwortest ein paar kurze Fragen – kein Lebenslauf, kein Anschreiben. Danach meldet sich unser Team persönlich bei dir.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Link to={this.quizLink} className="jl-cta">
            Jetzt bewerben <span style={{ fontWeight: 400, opacity: .85 }}>· dauert unter 60 Sek.</span>
          </Link>
          <Link to={this.infoLink} className="jl-cta-secondary">
            Mehr Infos zum Job
          </Link>
        </div>
      </section>
    );
  }

  renderStickyBar() {
    return (
      <div className="jl-stickybar">
        <Link to={this.quizLink} className="jl-cta">
          Jetzt bewerben <span style={{ fontWeight: 400, opacity: .85 }}>· dauert unter 60 Sek.</span>
        </Link>
      </div>
    );
  }

  renderFooter() {
    return (
      <footer className="jl-footer">
        <p style={{ marginBottom: 18 }}>
          Aus Gründen der Lesbarkeit wird auf dieser Website darauf verzichtet, durchgehend geschlechtsspezifische
          Formulierungen zu verwenden. Soweit personenbezogene Bezeichnungen nur in männlicher Form angeführt sind,
          beziehen sie sich auf Mann, Frau und Divers in gleicher Weise. Dies soll jedoch keinesfalls eine
          Geschlechterdiskriminierung oder eine Verletzung des Gleichheitsgrundsatzes zum Ausdruck bringen.
        </p>
        <div style={{ fontWeight: 600, color: '#1D2732' }}>Powered by ZoneAid</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
          <Link target="_blank" rel="noopener noreferrer" to="/job/impressum">Impressum</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/agb">Nutzungsbedingungen</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/datenschutz">Datenschutzerklärung</Link>
        </div>
      </footer>
    );
  }

  render() {
    return (
      <div className="jl-page">
        {this.renderStyles()}
        {this.renderHero()}
        {this.renderEarlyCta()}
        {this.renderFacts()}
        {this.renderQuizPitch()}
        {this.renderFooter()}
      </div>
    );
  }
}

export default JobLanding;
